import { useEffect } from 'react';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import HeroSection from './components/HeroSection';
import ServicesSection from './components/ServicesSection';
import MortgageRatesChart from './components/MortgageRatesChart';
import ServiceAreaSection from './components/ServiceAreaSection';
import TrustSection from './components/TrustSection';
import { Link } from 'react-router-dom';

export default function Home() {
  useEffect(() => {
    // Set page-specific meta tags
    document.title = 'Ontario Mortgage Broker | Tony Monteiro';
    
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'Licensed Level 2 mortgage agent helping Ontario homeowners secure the best mortgage rates, refinance options, and home loans across Waterloo, Brant, and Wellington.');
    }
    
    // Update meta keywords
    let metaKeywords = document.querySelector('meta[name="keywords"]');
    if (!metaKeywords) {
      metaKeywords = document.createElement('meta');
      metaKeywords.setAttribute('name', 'keywords');
      document.head.appendChild(metaKeywords);
    }
    metaKeywords.setAttribute('content', 'mortgage broker Waterloo, mortgage agent Ontario, best mortgage rates GGH, refinance mortgages Brant, Wellington home loans, first-time buyer mortgage, trusted mortgage expert Ontario');
    
    // Set canonical URL
    let canonical = document.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement('link');
      canonical.setAttribute('rel', 'canonical');
      document.head.appendChild(canonical);
    }
    canonical.setAttribute('href', 'https://mortgagesforyoubytony.ca/');

    // Add JSON-LD schema
    const existingSchema = document.querySelector('script[type="application/ld+json"]');
    if (existingSchema) {
      existingSchema.remove();
    }
    
    const schemaScript = document.createElement('script');
    schemaScript.type = 'application/ld+json';
    schemaScript.textContent = '{"@context":"https://schema.org","@graph":[{"@type":["LocalBusiness","MortgageBroker"],"@id":"https://mortgagesforyoubytony.ca/#org","name":"Tony Monteiro Mortgages","url":"https://mortgagesforyoubytony.ca/","image":"https://mortgagesforyoubytony.ca/favicon.ico","logo":"https://mortgagesforyoubytony.ca/favicon.ico","telephone":"+1-519-658-3026","email":"tjcmonteiro@rogers.com","identifier":"Lic# 13121","address":{"@type":"PostalAddress","addressRegion":"ON","addressCountry":"CA"},"areaServed":["Waterloo","Brant County","Wellington County","Greater Golden Horseshoe"],"openingHours":"Mo-Fr 09:00-19:00","priceRange":"$$"},{"@type":"BreadcrumbList","itemListElement":[{"@type":"ListItem","position":1,"name":"Home","item":"https://mortgagesforyoubytony.ca/"}]}]}';
    document.head.appendChild(schemaScript);
  }, []);

  return (
    <div className="min-h-screen">
      <Header />
      <main>
        <HeroSection />
        <ServicesSection />
        
        {/* Refinance CTA Section */}
        <section className="py-16 bg-gradient-to-r from-blue-50 to-indigo-50">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
            <div className="bg-white rounded-2xl shadow-lg p-8 max-w-2xl mx-auto">
              <h3 className="text-2xl font-bold text-gray-900 mb-4">
                Looking to refinance? Explore your options here.
              </h3>
              <p className="text-gray-600 mb-6">
                Discover how refinancing can help you save money, access equity, or consolidate debt with better rates and terms.
              </p>
              <Link
                to="/refinance-options"
                className="inline-flex items-center px-6 py-3 bg-blue-600 text-white font-semibold rounded-lg hover:bg-blue-700 transition-colors whitespace-nowrap"
              >
                Explore Refinance Options
                <i className="ri-arrow-right-line ml-2"></i>
              </Link>
            </div>
          </div>
        </section>
        
        <MortgageRatesChart />
        <ServiceAreaSection />
        <TrustSection />
      </main>
      <Footer />
    </div>
  );
}